var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import "./errorMessage.css";
/**
 * This Error Component is used to add error message for all the field types
 */
export default function ErrorMessage(props) {
    return (_jsx("div", __assign({ id: props.key, className: "font-medium not-italic set-line-height error ".concat(props.classname) }, { children: props.message })));
}
